import React, { useState } from 'react';
import './AddBhajanForm.css';

const AddBhajanForm = ({ categoryId, categoryName, onClose, onBhajanAdded }) => {
  const [formData, setFormData] = useState({
    title: '',
    bhajan_text: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim() || !formData.bhajan_text.trim()) {
      setError('Both title and bhajan text are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`https://pooja-path-1.onrender.com/api/bhajan_sangrah/categories/${categoryId}/bhajans/add/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title.trim(),
          bhajan_text: formData.bhajan_text.trim()
        }),
      });

      if (response.ok) {
        const data = await response.json();
        alert('Bhajan added successfully!');
        onBhajanAdded();
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to add bhajan');
      }
    } catch (error) {
      console.error('Error adding bhajan:', error);
      setError('Failed to add bhajan. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content bhajan-form-modal">
        <div className="modal-header">
          <h3>🎵 Add Bhajan to "{categoryName}"</h3>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="add-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="title" className="form-label">
              Bhajan Title *
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter bhajan title"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="bhajan_text" className="form-label">
              Bhajan Text *
            </label>
            <textarea
              id="bhajan_text"
              name="bhajan_text"
              value={formData.bhajan_text}
              onChange={handleInputChange}
              className="form-textarea"
              placeholder="Enter the complete bhajan text..."
              rows="12"
              required
            />
            <div className="character-count">
              {formData.bhajan_text.length} characters
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? '❳ Adding...' : '✅ Add Bhajan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBhajanForm;